// extracted by mini-css-extract-plugin
export default {"loader_container":"MediumLoader_loader_container__mKLK2","loader":"MediumLoader_loader__jbqkW","spinner-c7wet2":"MediumLoader_spinner-c7wet2__B3jfQ"};